import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';

export const BET_VALUES_SLICE_KEY = 'betValues';

export interface BetValuesSliceState {
  values: number[];
  currencyCode: string;
  currentBetAmount: number;
}

export const initialState: BetValuesSliceState = {
  values: [10, 20, 50, 100, 200],
  currencyCode: '',
  currentBetAmount: 10,
};

const betValuesSlice = createSlice({
  name: BET_VALUES_SLICE_KEY,
  initialState,
  reducers: {
    setBetValue: (
      state,
      action: PayloadAction<{ index: number; value: number }>
    ) => {
      const { index, value } = action.payload;
      if (index >= 0 && index < state.values.length) {
        state.values[index] = value;
      }
    },
    setBetValues: (state, action: PayloadAction<number[]>) => {
      state.values = action.payload.slice(0, 5);
    },
    resetBetValues: (state) => {
      state.values = initialState.values;
    },
    setCurrentBetAmount: (state, action: PayloadAction<number>) => {
      state.currentBetAmount = action.payload;
    },
    incrementBetAmount: (state, action: PayloadAction<number>) => {
      const step = action.payload;
      state.currentBetAmount += step;
    },
    decrementBetAmount: (state, action: PayloadAction<number>) => {
      const step = action.payload;
      const newAmount = state.currentBetAmount - step;
      state.currentBetAmount = Math.max(newAmount, step);
    },
    setCurrencyCode: (state, action: PayloadAction<string>) => {
      state.currencyCode = action.payload;
    },
  },
});

const betValuesReducer = betValuesSlice.reducer as Reducer;

export default betValuesReducer;

export const betValuesSelector = (state: {
  [BET_VALUES_SLICE_KEY]: BetValuesSliceState;
}) => state[BET_VALUES_SLICE_KEY];

export const betValuesActions = betValuesSlice.actions;
